__turbopack_context__.v({
  "admin-bg-danger": "Header-module-scss-module__wS1-Va__admin-bg-danger",
  "admin-bg-info": "Header-module-scss-module__wS1-Va__admin-bg-info",
  "admin-bg-primary": "Header-module-scss-module__wS1-Va__admin-bg-primary",
  "admin-bg-secondary": "Header-module-scss-module__wS1-Va__admin-bg-secondary",
  "admin-bg-success": "Header-module-scss-module__wS1-Va__admin-bg-success",
  "admin-bg-warning": "Header-module-scss-module__wS1-Va__admin-bg-warning",
  "admin-border": "Header-module-scss-module__wS1-Va__admin-border",
  "admin-border-dark": "Header-module-scss-module__wS1-Va__admin-border-dark",
  "admin-border-light": "Header-module-scss-module__wS1-Va__admin-border-light",
  "admin-rounded": "Header-module-scss-module__wS1-Va__admin-rounded",
  "admin-rounded-full": "Header-module-scss-module__wS1-Va__admin-rounded-full",
  "admin-rounded-lg": "Header-module-scss-module__wS1-Va__admin-rounded-lg",
  "admin-rounded-md": "Header-module-scss-module__wS1-Va__admin-rounded-md",
  "admin-rounded-sm": "Header-module-scss-module__wS1-Va__admin-rounded-sm",
  "admin-shadow-lg": "Header-module-scss-module__wS1-Va__admin-shadow-lg",
  "admin-shadow-md": "Header-module-scss-module__wS1-Va__admin-shadow-md",
  "admin-shadow-sm": "Header-module-scss-module__wS1-Va__admin-shadow-sm",
  "admin-sr-only": "Header-module-scss-module__wS1-Va__admin-sr-only",
  "admin-text-light": "Header-module-scss-module__wS1-Va__admin-text-light",
  "admin-text-muted": "Header-module-scss-module__wS1-Va__admin-text-muted",
  "admin-text-primary": "Header-module-scss-module__wS1-Va__admin-text-primary",
  "admin-text-secondary": "Header-module-scss-module__wS1-Va__admin-text-secondary",
  "header": "Header-module-scss-module__wS1-Va__header",
  "header__logo": "Header-module-scss-module__wS1-Va__header__logo",
  "header__nav": "Header-module-scss-module__wS1-Va__header__nav",
  "header__navLink": "Header-module-scss-module__wS1-Va__header__navLink",
  "header__navLink__active": "Header-module-scss-module__wS1-Va__header__navLink__active",
  "header__navLink__skeleton": "Header-module-scss-module__wS1-Va__header__navLink__skeleton",
  "pulse": "Header-module-scss-module__wS1-Va__pulse",
});
